// AccButton --------------------------------------------------
function AccButton(id, spr, frlbl, px, py, wid, hgt, lbl, enabled) {

/*
This is a simple clickable button which uses an html button for accessibility. 

Passed in paraments are 
	id = id of button
	spr = name of spritesheet containing button graphics
	frlbl = name of sprite label
	px = x position
	py = y position
	wid = width of active area of button
	hgt = height of active area of button
	lbl = button's accessibility label
	enabled = whether button is enabled
	
Dispatched events:
	BUTTON_DOWN
*/
	//Import classes
	var Container = include('createjs.Container'),
		Shape = include('createjs.Shape'),
		Sprite = include('createjs.Sprite'),
		EventDispatcher = include('springroll.EventDispatcher');
		
	this.view = new Container();
	// load sprite if available
	if(spr !== '') {
		this.bg = new Sprite(spr, frlbl);
	}
	else {
		this.bg = null;
	}
	this.actarea = new Shape();
	this.btn = document.createElement('button');
	this.ev_disp = new EventDispatcher();
	
	this.id = id;	
	this.enabled = enabled;
	this.pos_x = px;
	this.pos_y = py;
	this.width = wid;
	this.height = hgt;
	this.label = lbl;
	this.mute = false;

	this.init();

}

namespace('WGBH').AccButton = AccButton;

var p = AccButton.prototype;

// used to initialize the button
p.init = function() {
	// do if there's a background image
	if(this.bg !== null) {
		var bnds = this.bg.getBounds();
	
	// add active area - FOR TESTING ONLY
	// this.actarea.graphics.s('#00ff00').ss(2).dr(0, 0, this.width, this.height).ef();

		// center graphic within button area
		this.bg.x = (this.width - bnds.width) / 2;
		this.bg.y = (this.height - bnds.height) / 2;

		this.view.addChild(this.bg);
	//	this.view.addChild(this.actarea);	
		this.view.x = this.pos_x;
		this.view.y = this.pos_y;
	}	
	// set up html button
	this.btn.id = this.id;
	this.btn.className = app.config.GAME.BUTTONS.class;
	this.btn.setAttribute('aria-label', this.label);
	
	this.adjustButtonParam(1);
		
	// set up function bindings
	this.buttonActivated = this.buttonActivated.bind(this);
		
	this.btn.addEventListener('click', this.buttonActivated, false); 

	// check whether or not to enable the button
	if(this.enabled) {
		this.enableButton();
	}
	else {
		this.disableButton();
	}
};

// used to adjust html button when game is being resized
p.adjustButtonParam = function(scaling) {
	var bwid = this.width * scaling,
		bhgt = this.height * scaling,
		btop = this.pos_y * scaling,
		bleft = this.pos_x * scaling;
		
		this.btn.setAttribute('style', 'width:' + bwid.toString() + 'px;height:' + bhgt.toString() + 'px;top:' + btop.toString() + 'px;left:' + bleft.toString() + 'px;');
		this.btn.style.width = bwid.toString() + 'px';
		this.btn.style.height = bhgt.toString() + 'px';
		this.btn.style.top = btop.toString() + 'px';
		this.btn.style.left = bleft.toString() + 'px';
};

// used to trigger button clicked event
p.buttonActivated = function() {
	this.playVibration();
	if(app.click_stops_audio) {	
		app.voPlayer.stop();
	}
	if(!this.mute) {
		app.sound.play('sfx_click');
	}
	this.triggerMessageEvent('BUTTON_DOWN');
};

// used to play vibration
p.playVibration = function() {
	if(app.available_haptic) {
		window.navigator.vibrate(100);
	}
};

// used to enable the button
p.enableButton = function() {
	this.enabled = true;
	this.btn.disabled = false;
};

// used to disable the button
p.disableButton = function() {
	this.enabled = false;
	this.btn.disabled = true;
};

// used to clear the object
p.clearObject = function() {
	while(this.view.numChildren > 0) {
		this.view.removeChildAt(0);
	}
	this.btn.removeEventListener('click', this.buttonActivated, false); 
	this.bg = null;
	this.actarea = null;
	this.view = null;
};

// used to trigger various events
p.triggerMessageEvent = function(evt) {
	this.ev_disp.trigger(evt, {id:this.id});	
};	
